<div class="map-canvas" #mapCanvas [style.height]="_isFromSearchResults ? '950px' : '105%'">

</div>
<div class="deletLayer">
    <a class="button-action" (click)="deleteAllDrawnLayers()" title="{{ 'SearchResult.deleteButton' | translate }}"> <i class="fa fa-trash"></i></a>
</div>
<!-- [ngStyle]="{'height': (_isFromSearchResults ? '99%' : '')}" -->
